<template>
  <div class="pagination">
    <ul class="pagination__list">
      <li v-for="i in pages" :key="i" class="pagination__list-item">
        <button
          class="pagination__button"
          :class="{ 'pagination__button--active': currentPage === i }"
          :style="buttonStyles(currentPage === i)"
          @click="$emit('change-page', i)"
        >
          <span class="is-sr-only">Change to page {{ i }}</span>
          <span aria-hidden="true">{{ i + 1 }}</span>
        </button>
      </li>

      <!-- Show more pages -->
      <li v-if="count > 3" class="pagination__list-item pagination__list-item--more">
        <button
          class="pagination__button pagination__button--more"
          :class="{ 'pagination__button--active': currentPage >= 3 }"
          :style="buttonStyles(currentPage >= 3)"
          @click="toggleMorePages"
        >
          <span class="is-sr-only">Expand more pages</span>
          <span aria-hidden="true">•••</span>
        </button>

        <ul v-show="showMorePages" :class="moreClasses">
          <li v-for="i in count" :key="i" class="more__list-item more__list-item--sub">
            <button
              v-if="i > 2"
              class="more__button"
              :class="{ 'more__button--active': currentPage === i }"
              :style="moreButtonStyles(currentPage === i)"
              @click="$emit('change-page', i)"
            >
              <span class="is-sr-only">Change to page {{ i }}</span>
              <span aria-hidden="true">Page {{ i + 1 }}</span>
            </button>
          </li>
        </ul>
        <!-- /Show more pages -->
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    theme: {
      type: Object,
      validator(value) {
        return ['light', 'dark', 'custom'].includes(value.type);
      },
    },
    count: {
      type: Number,
      default() {
        return 0;
      },
    },
    currentPage: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      showMorePages: false,
    };
  },
  computed: {
    pages() {
      return this.count <= 3 ? this.count : 3;
    },
    moreClasses() {
      if (this.count > 8) {
        return 'more more-with-scroll';
      }

      return 'more';
    },
  },
  methods: {
    buttonStyles(isActive) {
      return {
        borderColor: this.theme.accent,
        color: isActive ? '#fff' : this.theme.accent,
        backgroundColor: isActive ? this.theme.accent : '#fff',
      };
    },

    moreButtonStyles(isActive) {
      return {
        // check for light mode since we can't use white for the text color, we'll settle for the accent color
        color: isActive && this.theme.type !== 'light' ? this.theme.background : this.theme.accent,
        backgroundColor: isActive ? '#f5f5f5' : null,
      };
    },

    toggleMorePages() {
      this.showMorePages = !this.showMorePages;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/_helpers';

.pagination {
  &__list {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
  &__list-item {
    list-style: none;
    padding: 0 0.25rem;
    // position: relative;
  }
  &__button {
    border: 2px solid #532AA2;
    padding: 6px 16px;
    color: #532AA2;
    background: #fff;
    border-radius: 8px;
    font-size: 16px;
    &:hover {
      cursor: pointer;
    }
    &--active {
      background: #532AA2;
      color: #fff;
    }
  }

  .more {
    position: absolute;
    max-height: 200px;
    bottom: 80px;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 0.5rem;
    border: 1px solid #f5f5f5;
    background: #FFFFFF;
    z-index: 300;
    box-shadow: 0px 1px 3px rgba(34, 32, 70, 0.2);
    overflow-y: hidden;
    &__list-item {
      list-style: none;
      width: 100%;
    }
    &__button {
      width: 100%;
      // @NOTE: if we see a gap in the scroll bar, we can use this
      // width: 101%;
      padding: 0.625rem 1.625rem;
      border: 0;
      font-weight: 500;
      background: #FFFFFF;
      &:hover {
        background: #f5f5f5;
        cursor: pointer;
      }
    }
  }

  .more-with-scroll {
    overflow-y: scroll;
    // @NOTE: if we see a gap in the scroll bar, we can use this
    // overflow-x: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// Pagination.vue?7d4bd466